import React from "react";

export const EngageAgent = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 55 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-82.000000, -58.000000)"
        fill="#353F52"
        fillRule="nonzero"
      >
        <g transform="translate(82.000000, 58.000000)">
          <g transform="translate(16.000000, 28.000000)">
            <path d="M33.5555556,25 L33.5555556,28 L28.0766284,25 L2,25 C0.8954305,25 0,24.1045695 0,23 L0,2 C0,0.8954305 0.8954305,0 2,0 L37,0 C38.1045695,0 39,0.8954305 39,2 L39,23 C39,24.1045695 38.1045695,25 37,25 L33.5555556,25 Z M31.5555556,23 L37,23 L37,2 L2,2 L2,23 L28.5883372,23 L31.5555556,24.6247077 L31.5555556,23 Z" />
            <path d="M6,8.5 L18,8.5 C18.5522847,8.5 19,8.05228475 19,7.5 C19,6.94771525 18.5522847,6.5 18,6.5 L6,6.5 C5.44771525,6.5 5,6.94771525 5,7.5 C5,8.05228475 5.44771525,8.5 6,8.5 Z" />
            <path d="M6,13.5 L26,13.5 C26.5522847,13.5 27,13.0522847 27,12.5 C27,11.9477153 26.5522847,11.5 26,11.5 L6,11.5 C5.44771525,11.5 5,11.9477153 5,12.5 C5,13.0522847 5.44771525,13.5 6,13.5 Z" />
            <path d="M6,18.5 L26,18.5 C26.5522847,18.5 27,18.0522847 27,17.5 C27,16.9477153 26.5522847,16.5 26,16.5 L6,16.5 C5.44771525,16.5 5,16.9477153 5,17.5 C5,18.0522847 5.44771525,18.5 6,18.5 Z" />
          </g>
          <g transform="translate(19.500000, 14.000000) scale(-1, 1) translate(-19.500000, -14.000000) ">
            <path d="M33.5555556,25 L33.5555556,28 L28.0766284,25 L2,25 C0.8954305,25 0,24.1045695 0,23 L0,2 C0,0.8954305 0.8954305,0 2,0 L37,0 C38.1045695,0 39,0.8954305 39,2 L39,23 C39,24.1045695 38.1045695,25 37,25 L33.5555556,25 Z M31.5555556,23 L37,23 L37,2 L2,2 L2,23 L28.5883372,23 L31.5555556,24.6247077 L31.5555556,23 Z" />
            <path d="M20,8.5 L32,8.5 C32.5522847,8.5 33,8.05228475 33,7.5 C33,6.94771525 32.5522847,6.5 32,6.5 L20,6.5 C19.4477153,6.5 19,6.94771525 19,7.5 C19,8.05228475 19.4477153,8.5 20,8.5 Z" />
            <path d="M12,13.5 L32,13.5 C32.5522847,13.5 33,13.0522847 33,12.5 C33,11.9477153 32.5522847,11.5 32,11.5 L12,11.5 C11.4477153,11.5 11,11.9477153 11,12.5 C11,13.0522847 11.4477153,13.5 12,13.5 Z" />
            <path d="M12,18.5 L32,18.5 C32.5522847,18.5 33,18.0522847 33,17.5 C33,16.9477153 32.5522847,16.5 32,16.5 L12,16.5 C11.4477153,16.5 11,16.9477153 11,17.5 C11,18.0522847 11.4477153,18.5 12,18.5 Z" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
